import {inject} from '@angular/core';
import {CanActivateFn} from '@angular/router';
import {AppLanguageService} from '../shared/i18n/app-language.service';

export const localizedPublicLanguageGuard: CanActivateFn = async (_route, state) => {
  try {
    await inject(AppLanguageService).activatePublicRouteLanguage(state.url);
    return true;
  } catch {
    return false;
  }
};
